<div class="jit-right-sidebar" [class.is-opened]="isOpened">
  <div class="jit-right-sidebar__internal" [class.is-opened]="isInternalOpened">
    <ng-content select="[internal]"></ng-content>
  </div>
  <div class="jit-right-sidebar__content">
    <ng-content select="[content]"></ng-content>
  </div>
</div>
<div class="jit-right-sidebar__overlay" [class.is-opened]="isOpened"></div>